import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { gameResultStore, isMobile, RoundStatus } from '@pascal/pascal-core';

const trianglesIcons = {
  up: '-1',
  down: '',
  equal: '-2',
};
const RESULTS_LIST_LENGTH = isMobile() ? 5 : 7;
export const LastResults = observer(() => {
  const { gameResults } = gameResultStore;

  const lastResults = useMemo(
    () => gameResults.filter((item) => item.status === RoundStatus.Finished).slice(0, RESULTS_LIST_LENGTH),
    [gameResults]
  );

  return (
    <div className='live-coefficient-block'>
      {lastResults.map((result, i) => {
        return (
          <div className='live-coefficient-row' key={i}>
            <div className='live-coefficient-icon'>
              {i || i === 0 ? (
                <i
                  className={`ui-lib-Triangle Triangle${
                    result.roundData.resultPoint < result.roundData.previousPoint
                      ? trianglesIcons.down
                      : result.roundData.resultPoint > result.roundData.previousPoint
                      ? trianglesIcons.up
                      : trianglesIcons.equal
                  }`}
                />
              ) : (
                <></>
              )}
            </div>
            <div className='live-coefficient-count'>{result.roundData.resultPoint}</div>
          </div>
        );
      })}
    </div>
  );
});
